import { render, staticRenderFns } from "./ActiveSubstanceEdit.vue?vue&type=template&id=60a80b5a&scoped=true&"
import script from "./ActiveSubstanceEdit.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a80b5a",
  null
  
)

export default component.exports